import React, { useState, useEffect } from "react";
import quranRawData from "../../data/quran/quran.json"; // Import Quran Arabic Text
import translationRawData from "../../data/quran/editions/en.json";
import transliterationRawData from "../../data/quran/editions/transliteration.json"; // Import transliteration
import {
  Ayah,
  QuranChapters,
  QuranDataType,
} from "../../classes/QuranDataType";
import { TranslationDataType } from "../../classes/TranslationDataType";

// Explicitly type the imported JSON data
const quranData: QuranDataType = quranRawData as QuranDataType;
const translationData: TranslationDataType =
  translationRawData as TranslationDataType;
const transliterationData: TranslationDataType =
  transliterationRawData as TranslationDataType;

const QuranReader: React.FC<{
  selectedSurah: QuranChapters;
  showTranslation: boolean;
  showTransliteration: boolean;
}> = ({ selectedSurah, showTranslation, showTransliteration }) => {
  const [ayahs, setAyahs] = useState<Ayah[]>([]);
  const [translations, setTranslations] = useState<Ayah[]>([]);
  const [transliterations, setTransliterations] = useState<Ayah[]>([]);

  useEffect(() => {
    const surahKey = selectedSurah.id.toString(); // Convert number to string for indexing
    setAyahs(quranData[surahKey] || []);
    setTranslations(translationData[surahKey] || []);
    setTransliterations(transliterationData[surahKey] || []);
  }, [selectedSurah]);

  return (
    <div className="p-4 flex flex-col justify-center items-center">
      <h2 className="font-grgrifter tracking-wider text-2xl text-[#AFAEB3] mb-8 flex flex-col justify-center items-center mt-6">
        {selectedSurah.transliteration} {selectedSurah.name}
        <span className="text-xl">({selectedSurah.translation})</span>
      </h2>
      <div className="space-y-4">
        {ayahs.map((ayah, index) => (
          <div key={ayah.verse} className="border-b pb-2">
            <p className="text-right text-lg font-arabic">{ayah.text}</p>

            {/* Transliteration (if enabled) */}
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                showTransliteration
                  ? "opacity-100 max-h-40"
                  : "opacity-0 max-h-0"
              }`}
            >
              <p className="text-sm text-gray-800 italic">
                {transliterations[index]?.text ||
                  "Transliteration not available"}
              </p>
            </div>

            {/* Translation (if enabled) */}
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                showTranslation ? "opacity-100 max-h-40" : "opacity-0 max-h-0"
              }`}
            >
              <p className="text-sm text-gray-600">
                <strong>{ayah.verse}:</strong>{" "}
                {translations[index]?.text || "Translation not available"}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuranReader;
